module.exports = __webpack_public_path__ + "img/Outgoing Job Pending.ab3cfcf7.png";